import { memo } from 'react';
import cn from 'classnames';

import CLIENT_TAGS_1 from 'assets/tags/client-tags-1.svg';
import CLIENT_TAGS_1_DARK from 'assets/tags/client-tags-1-dark.svg';
import CLIENT_TAGS_2 from 'assets/tags/client-tags-2.svg';
import CLIENT_TAGS_2_DARK from 'assets/tags/client-tags-2-dark.svg';
import S from 'constants/string.const';
import { useHelpLinks } from 'hooks/useHelpLinks.hook';
import { useTranslation } from 'providers/GILT.provider';

import CN from './SubTitle.module.scss';

const SubTitle = ({ darkTheme }) => {
  const { t } = useTranslation();
  const { clientTagsHelpLink } = useHelpLinks();

  return (
    <div data-bem="SubTitle" className={cn({ [CN.container]: true, [CN.dark]: darkTheme })}>
      <ul data-bem="SubTitle__list" className={CN.titleList}>
        <li>{t('clientTags.subtitle1')}</li>
        <li>{t('clientTags.subtitle2')}</li>
        <li>{t('clientTags.subtitle3')}</li>
        <li>{t('clientTags.subtitle4')}</li>
        <li>
          {t('clientTags.subtitle5Part1')}
          {S.space}
          <a href={clientTagsHelpLink} className={CN.subTitleLink} rel="noopener noreferrer" target="_blank">
            {t('clientTags.subtitle5Part2')}
          </a>
        </li>
      </ul>
      <img data-bem="SubTitle__image_1" src={darkTheme ? CLIENT_TAGS_1_DARK : CLIENT_TAGS_1} alt="Custom tag example one." className={CN.img1} />
      <img data-bem="SubTitle__image_2" src={darkTheme ? CLIENT_TAGS_2_DARK : CLIENT_TAGS_2} alt="Custom tag example two." className={CN.img2} />
    </div>
  );
};

export default memo(SubTitle);
